import React, { FC } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useChannelContext } from 'stream-chat-react';

import { Loaders } from 'components';

const useStyles = makeStyles(theme => ({
  loader: {
    marginLeft: theme.spacing(0.5),
  },
}));

const TypingIndicator: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { client, typing } = useChannelContext();

  if (!client || !typing) {
    return null;
  }

  const users = Object.values(typing)
    .filter(({ user }) => user?.id !== client.user?.id)
    .map(({ user }) => user.name || user.id);

  let text = '';

  if (users.length === 1) {
    text = t('content:single_user_typing', { user: users[0] });
  } else if (users.length === 2) {
    text = t('content:two_users_typing', { user1: users[0], user2: users[1] });
  } else if (users.length > 2) {
    text = t('content:multiple_users_typing', { user: users[0], count: users.length - 1 });
  }

  if (!text.length) {
    return null;
  }

  return (
    <Grid container alignItems="center" justify="flex-start">
      <Grid item>
        <Typography>{text}</Typography>
      </Grid>

      <Grid item className={classes.loader}>
        <Loaders.Standard width={65} height={40} />
      </Grid>
    </Grid>
  );
};

export default TypingIndicator;
